import type { ServiceTypeSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/serviceTypeSlugEnum';

import {
  ValuePropFilterOptionsCtaClick,
  ValuePropFilterOptionType,
} from '../../utilities/analyticsEvents';

function onValuePropFilterOptionsCtaClick(serviceTypeSlug: ServiceTypeSlugEnum) {
  return (valuePropFilterOption: ValuePropFilterOptionType) => {
    new ValuePropFilterOptionsCtaClick({
      serviceTypeSlug,
      valuePropFilterOption,
    }).fireCrossPageEvent();
  };
}
export default onValuePropFilterOptionsCtaClick;
